import { ReactModel } from "../../react-model/react-model";

type IMap = {[id:string]:any};
/**
 * call event onModelChange() to update element properties
 */
export function useOnModelChange<T>(
	model: ReactModel<T>,
	onModelChange: undefined | ((state: any) => void | React.HTMLAttributes<any>),
	props: IMap,
) {
	if (onModelChange) {
		const { state: full_state } = model.useModel();
		//call the event
		const new_props = onModelChange(full_state);
		//merge properties
		if (new_props) {
			const old_style = Object.isFrozen(props.style) ? {...props.style}:props.style;
			Object.assign(props, new_props);
			//merge 'style'
			if (old_style) {
				props.style = Object.assign(old_style, props.style);
			}
		}
	}
}
